import type { Items } from "@classes-service-types/items";
import type { Ref } from "vue";

/**
 * Learning Service `Items` (programming session) includes these optional cent fields.
 * The CMS editor model is wider; we only declare the slice this block reads/writes.
 */
export type ProgramSessionConfigurableFeesModel = Pick<
  Items,
  "application_fee_in_cents" | "confirmation_deposit_in_cents"
> & {
  owner_entity_id?: string;
} & Record<string, unknown>;

export type ApplicationRequirementsFeesPaymentsProps = {
  modelValue: ProgramSessionConfigurableFeesModel;
  canEditFees?: boolean;
};

export type SessionFeeStoredCents = number | null | undefined;

/**
 * Checkbox state for Application Fee / Confirmation Deposit in the CMS:
 * ON when the in-memory session has a **positive** cent amount (user is charging a fee).
 * OFF when the value is missing, zero, or not a number — that maps to “no fee” / $0 after save.
 */
export const feeCheckboxIsOnFromSessionCents = (cents: SessionFeeStoredCents): boolean => {
  return typeof cents === "number" && !Number.isNaN(cents) && cents > 0;
};

export type SessionFeeSnapshot = {
  ownerEntityId: string | undefined;
  applicationFeeInCents: number | undefined;
  confirmationDepositInCents: number | undefined;
};

export type UseSuppressedSessionFeesArgs = {
  programSession: Ref<ProgramSessionConfigurableFeesModel>;
  suppressed: Ref<boolean>;
  selectedOwnerEntityId: Ref<string>;
  loading: Ref<boolean>;
};
